var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0C1014",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.573 25.46a.294.294 0 00.005-.013zm.446-1.087a7 7 0 01.949-1.483c.717-.874 1.644-1.586 2.814-2.085 3.818-1.628 6.468-5.486 6.468-9.664C21.25 5.4 16.659.75 11 .75S.75 5.4.75 11.14c0 4.213 2.519 7.89 6.42 9.673 1.982.906 3.19 2.168 3.849 3.56z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.925 13.725c-1.04 1.844-2.914 2.775-5.515 2.775-3.137 0-5.286-.915-6.335-2.775-.17-.3-.041-.668.286-.823.327-.155.729-.038.898.262.79 1.4 2.468 2.114 5.151 2.114 2.126 0 3.533-.699 4.331-2.114.17-.3.571-.417.898-.262.327.155.455.523.286.823zM8 9.5c-.71 0-1.286-.56-1.286-1.25S7.29 7 8 7c.71 0 1.286.56 1.286 1.25S8.71 9.5 8 9.5zm6 0c-.71 0-1.286-.56-1.286-1.25S13.29 7 14 7c.71 0 1.286.56 1.286 1.25S14.71 9.5 14 9.5z",
    fill: "#0C1014",
    fillRule: "nonzero",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledIcon);
export default __webpack_public_path__ + "static/media/disabledIcon.154a038bc9a42c2b9c656027900766a2.svg";
export { ForwardRef as ReactComponent };